// extracted by mini-css-extract-plugin
export default {"pContainer":"info_pContainer__lQxpd","cloud-h1":"info_cloud-h1__sD9dj","welcome-h1":"info_welcome-h1__1NsV0","info-main-div":"info_info-main-div__QZNVi"};